module.exports = __webpack_public_path__ + "img/maker-2.1eabd569.jpg";